import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';

/** Shows a loading indicator, or the error once loading failed. */
@Component({
  selector: 'app-load-status',
  template: `
    @if (error()) {
      <ep-alert type="alert" color="danger" variant="alt">
        <span slot="header">{{ error() }}</span>
      </ep-alert>
    } @else {
      <ep-progress indeterminate [attr.aria-label]="loadingLabel()"></ep-progress>
    }
  `,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadStatus {
  readonly error = input<string | null>(null);
  readonly loadingLabel = input.required<string>();
}
